/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CourtDayType = {
    Weekday: 'Weekday',
    Rule: 'Rule',
    SingleDates: 'SingleDates'
} as const;
export type CourtDayType = typeof CourtDayType[keyof typeof CourtDayType];


export function instanceOfCourtDayType(value: any): boolean {
    for (const key in CourtDayType) {
        if (Object.prototype.hasOwnProperty.call(CourtDayType, key)) {
            if (CourtDayType[key as keyof typeof CourtDayType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CourtDayTypeFromJSON(json: any): CourtDayType {
    return CourtDayTypeFromJSONTyped(json, false);
}

export function CourtDayTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtDayType {
    return json as CourtDayType;
}

export function CourtDayTypeToJSON(value?: CourtDayType | null): any {
    return value as any;
}

export function CourtDayTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CourtDayType {
    return value as CourtDayType;
}

